// noinspection RegExpRedundantEscape
const ADDRESS_LINE1_REGEX =
  /^(([ A-Za-z0-9\\-\\_\\.\\:\\,\\'\\&\\#\\/\\\\]|(&amp;))+)$/; // ADDRESS_LINE_REGEX
const ADDRESS_LINE2_REGEX =
  /^(([ ]*)|([ A-Za-z0-9\\-\\_\\.\\:\\,\\'\\&\\#\\/\\\\]|(&amp;))+)$/;
const ADDRESS_STREET_OR_CITY =
  /^[A-Za-z0-9][ A-Za-z0-9-_.,'&@]*[A-Za-z0-9-_.,'&@]$/; // ADDRESS_STREET_OR_CITY
const NAME_REGEX = /^[A-Za-z0-9]+[ A-Za-z0-9\-_.,'&]*$/;
const LAST_NAME = /^[A-Za-z]+[ A-Za-z-_.,'&]*$/;
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // EMAIL
const zipRegex = /^[0-9]*$/;
const poBoxLine1Validation =
  /^((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|post.office.box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
const accountNumberRegex = /^[a-zA-Z0-9]+$/;
const NUMBER_REGEX = /^[0-9]*$/;
const SSN_REGEX = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
const DATE_OF_BIRTH = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
const ACCOUNT_NUMBER_REGEX = /^(([ ]*)|([ 0-9a-zA-Z_-]+))$/;
const EMPLOYER_NAME_REGEX = /^[A-Za-z0-9]+[ A-Za-z0-9-_.,'*&]*$/;
const ZIPCODE_REGEX = /^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$/;
const CITY_REGEX = /^[a-zA-Z\s]+$/;
const RELATIONSHIP_REGEX = /^[A-Za-z]+[ A-Za-z-_.,'&]*$/;
const MINIMAL_VALUE_1000_ALL_CASH = /^(?:[1-9][0-9]{3,}|1000)$/;
const SHARES_VALUE_REGEX = /^[0-9]+$/;
const AMOUNT_WITH_TWO_DECIMAL_VALUES = /^\d*\.?\d{0,2}$/;

export const beaconPattern = {
  nameRegex: NAME_REGEX,
  addressOneRegex: ADDRESS_LINE1_REGEX,
  addressTwoRegex: ADDRESS_LINE2_REGEX,
  addressCityRegex: ADDRESS_STREET_OR_CITY,
  accountNumberRegex: ACCOUNT_NUMBER_REGEX,
  numberOnlyRegex: NUMBER_REGEX,
  dateOfBirth: DATE_OF_BIRTH,
  emailRegex: EMAIL_REGEX,
  SsnRegex: SSN_REGEX,
  employerName: EMPLOYER_NAME_REGEX,
  zipCode: ZIPCODE_REGEX,
  city: CITY_REGEX,
  relationshipRegex: RELATIONSHIP_REGEX,
  lastName: LAST_NAME,
  fundingAccountNumberRegex: accountNumberRegex,
  minimalval1000AllCashRegex: MINIMAL_VALUE_1000_ALL_CASH,
  sharesRegex: SHARES_VALUE_REGEX,
  amountWithTwoDecimals: AMOUNT_WITH_TWO_DECIMAL_VALUES,
};

export const isFieldRequired = (field) => {
  if (typeof field === 'number' && isFinite(field)) {
    return true;
  } else if (field && field.length > 0 && field !== 'UNKNOWN') {
    return true;
  }
  return false;
};

export const isValidMiddleName = (name) => {
  return name && name.trim().length >= 1 && NAME_REGEX.test(name.trim());
};

export const isValidName = (name) => {
  return name && name.trim().length >= 2 && NAME_REGEX.test(name.trim());
};

export const isRequiredValidName = (name) => {
  return isFieldRequired(name) && isValidName(name);
};

export const isValidRequiredUsPhoneNumber = (phone) => {
  return phone && phone.length === 10;
};

export const isValidNonUSPhoneNumber = (phoneNumber) => {
  return phoneNumber && phoneNumber.length <= 12;
};

export const isRequiredValidUsAndNonUsPhoneNumber = (phone) => {
  return (
    isFieldRequired(phone) &&
    (isValidRequiredUsPhoneNumber(phone) || isValidNonUSPhoneNumber(phone))
  );
};

export const isValidAddressOne = (address) => {
  return address && address.length <= 35 && ADDRESS_LINE1_REGEX.test(address);
};

export const isValidAddressNoPoBox = (address) => {
  return address && address.length <= 35 && !poBoxLine1Validation.test(address);
};

export const isValidAddressTwo = (address) => {
  return (
    !address ||
    (address && address.length <= 35 && ADDRESS_LINE2_REGEX.test(address))
  );
};

export const isValidCity = (city) => {
  return city && city.length <= 35 && ADDRESS_STREET_OR_CITY.test(city);
};

export const isValidZip = (zip) => {
  return zip && zip.length === 5 && zipRegex.test(zip);
};

export const isValidRequiredAccountNumber = (accountNumber) => {
  return (
    accountNumber &&
    isFieldRequired(accountNumber) &&
    accountNumber.length >= 2 &&
    accountNumberRegex.test(accountNumber)
  );
};

export const isRequiredValidAddress = (
  addressMilitary,
  addressOne,
  addressTwo,
  addressCity,
  addressState,
  addressZip
) => {
  return (
    isFieldRequired(addressOne) &&
    isFieldRequired(addressCity) &&
    isFieldRequired(addressState) &&
    isFieldRequired(addressZip) &&
    isValidAddressOne(addressOne) &&
    isValidAddressTwo(addressTwo) &&
    (!addressMilitary ? isValidCity(addressCity) : true) &&
    isValidZip(addressZip)
  );
};

export const checkPatternValidation = (fieldPattern, fieldValue) => {
  if (fieldPattern?.toString().length > 0 && fieldValue) {
    const pattern = new RegExp(fieldPattern);
    return pattern.test(fieldValue?.trim());
  }
  return false;
};

export const isValidTaxId = (SSN) => {
  return !SSN || SSN.length === 9;
};

export const isRequiredValidSSN = (SSN) => {
  return isFieldRequired(SSN) && isValidTaxId(SSN);
};

export const isValidEmail = (email) => {
  return !email || (email && email.length > 0 && EMAIL_REGEX.test(email));
};

export const pdfGeneration = (response) => {
  const blob = new Blob([response.body], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const fileName = `Document_${new Date()
    .toISOString()
    .replace(/[:.-]/g, '')}.pdf`;
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return;
};

export const getMinorData = (agreementParties) => {
  const minrFullName =
    agreementParties[0]?.roleCode === 'MINR'
      ? agreementParties[0]?.fullName
      : agreementParties[1]?.fullName;
  const nameSplit = minrFullName.split(' ');

  return {
    firstName: nameSplit[0],
    middleName:
      nameSplit.length > 2
        ? nameSplit.slice(1, nameSplit.length - 1).join(' ')
        : '',
    lastName: nameSplit[nameSplit.length - 1],
  };
};
